import { FlowContext, FlowDispatchContext, UseFlowTuple } from '@app/context/FlowContext';
import { useContext } from 'react';

export function useFlow(): UseFlowTuple {
  const flow = useContext(FlowContext);
  const dispatchFlow = useContext(FlowDispatchContext);
  return [flow, dispatchFlow];
}
